var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-header flex flex-wrap items-center"},[(_vm.can.create)?_c('alt-auto-button',{staticClass:"mr-1",attrs:{"type":"button","text":"+ Инвентаризация"},on:{"click":_vm.startCreate}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }